"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;
var _internal = require("../../../hooks/internal");
var _useTranslations = require("../../../hooks/useTranslations");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Title = () => {
  const {
    originalItemCode
  } = (0, _internal.useSharedConfiguration)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  if (originalItemCode) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      variant: "h4",
      children: translations.replaceWith
    });
  }
  return null;
};
exports.Title = Title;